/*! external links */
$(document).ready(function () {

    // Add attributes to external links
    $('a').each(function (e) {
        var tmpHREF = $(this).attr('href');

        // Filter for href outside domain
        if (this.host != window.location.host &&
            tmpHREF != null &&
            !tmpHREF.toLowerCase().startsWith('https://ecology.wa.gov') &&
            !tmpHREF.toLowerCase().startsWith('mailto') &&
            !tmpHREF.toLowerCase().startsWith('javascript') &&
            !tmpHREF.toLowerCase().startsWith('#')) {

            // A11Y: Announce leaving site and new window
            var title = "";
            if ($(this).attr("title")) {
                title += $(this).attr("title");
                title += ": ";
            }
            title += "Link leaves our site, opens a new window";
            $(this).addClass('external-link');
            $(this).attr("target", "_blank");
            $(this).attr("title", title);
        }
    });
});